module.exports = __webpack_public_path__ + "img/bus_active.9fb72161.svg";